import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Replaces the old hardcoded "Dev / Guru workspace" block in Chat.js / Admin.js
// with the real signed-in Google Workspace user, plus a sign-out action.
export default function AccountMenu({ style }) {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  if (!user) return null;

  const initial = (user.name || user.email || '?').trim().charAt(0).toUpperCase();

  const handleSignOut = async () => {
    setOpen(false);
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="gpt-sidebar-account-wrap" style={style} ref={wrapRef}>
      {open && (
        <div className="gpt-account-menu">
          <div className="gpt-account-menu-email">{user.email}</div>
          <button className="gpt-account-menu-item" onClick={handleSignOut}>
            🚪 Sign out
          </button>
        </div>
      )}
      <div className="gpt-sidebar-account" onClick={() => setOpen((v) => !v)}>
        <div className="gpt-account-avatar">
          {user.picture
            ? <img src={user.picture} alt={user.name} className="gpt-account-avatar-img" referrerPolicy="no-referrer" />
            : initial}
        </div>
        <div className="gpt-account-info">
          <div className="gpt-account-name">{user.name}</div>
          <div className="gpt-account-sub">{user.is_admin ? 'Knowledge Admin' : 'Standard User'}</div>
        </div>
        <span className="gpt-account-chevron">⌄</span>
      </div>
    </div>
  );
}
